import { Button, Form, Row, Col, Spinner } from "reactstrap";

import { ChangeEvent, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { UserProps, UserToken } from "../../context/hooks/useAuth";
import InputPassword from "../../components/Inputs/InputPassword";
import InputEmailLogin from "../../components/Inputs/InputEmailLogin";
import "./ActiveUserInfo.css";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import { UserTypeContext } from "../../context/UserTypeContext";
import { jwtDecode } from "jwt-decode";

const ActiveUser = () => {
  const { activeUser } =
    useContext(AuthContext);
  const { getUsersById, formValuesUsers } = useContext(UserTypeContext);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 650);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 650);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
    {!isMobileView && (
      <div style={{ position: "absolute", top: "30px", right: "10px" }}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            window.location.href = "/auth/login";
          }}
          className="button-create-user"
          type="button"
        >
          <Person2OutlinedIcon style={{ color: "#DCAC36" }} />
          Login
        </Button>
      </div>
    )}
    <Row className="justify-content-center">
      <Col
        lg="10"
        md="7"
        className="d-flex"
        style={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "40px",
        }}
      >
        <img
          style={{ width: "50%" }}
          alt="Logo"
          src={require("../../assets/img/brand/logoendocpng.png")}
        />
  
        <div className="d-flex" style={{ flexDirection: "column" }}>
          <span
            style={{
              textAlign: "center",
              letterSpacing: "5.76px",
              color: "#002231",
              opacity: 1,
              fontSize: "24px",
            }}
          >
            Confirme sua conta!{" "}
          </span>
          <span
            style={{
              textAlign: "center",
              letterSpacing: "2.24px",
              color: "#002231",
              opacity: 0.5,
              fontSize: "14px",
            }}
          >
            Um e-mail foi enviado para <strong>{formValuesUsers.email}</strong>. Por favor, verifique sua caixa de entrada (ou spam) e clique no link para confirmar a criação da sua conta. 
          </span>
        </div>
  
        <div className="px-lg-5" style={{ width: "84%" }}>
          <div className="text-center d-flex justify-content-center">
            <Button
              onClick={() => (window.location.href = "/auth/login")}
              className="my-4 button-login"
              type="button"
            >
              Voltar para Login
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  </>
  );
};

export default ActiveUser;
